import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import Loading from 'src/components/Loading/Loading'
import { FormattedMessage } from 'react-intl'
import useAssociate from 'src/hooks/useAssociate'
import { AssociateError } from 'src/util/associate'

import './Associate.sass'

interface AssociateParams {
  id: string,
  secret: string,
}

const Associate = () => {
  const [status, setStatus] = useState<'loading' | 'error'>('loading')
  const { id: userId, secret: urlSecret } = useParams<AssociateParams>()
  const history = useHistory()
  const { associateUser } = useAssociate()

  useEffect(() => {
    try {
      associateUser(userId, urlSecret)
    } catch (err) {
      if (err instanceof AssociateError) {
        setStatus('error')
      }
    }
  }, [userId, urlSecret])

  return (
    <div id="associate" className="page split">
      <header className="item left">
        <div className="logo" />
      </header>
      <section className="item right">
        <div className="wrapper">
          {status === 'loading'
            ? <Loading />
            : <div className="associate-error">
                <h2>Error</h2>
                <p className="error-description"><FormattedMessage id="two-factor-associate.error" /></p>
                <button className="filled" onClick={() => history.replace('/')}>
                  <FormattedMessage id="two-factor-associate.error-go-home" />
                </button>
              </div>
          }
        </div>
      </section>
    </div>
  )
}

export default Associate
